'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _YellowLineSVG = require('../../svg/YellowLineSVG');

var _YellowLineSVG2 = _interopRequireDefault(_YellowLineSVG);

var _Wrapper = require('./components/Wrapper');

var _Wrapper2 = _interopRequireDefault(_Wrapper);

var _InfoWrapper = require('./components/InfoWrapper');

var _InfoWrapper2 = _interopRequireDefault(_InfoWrapper);

var _ImageWrapper = require('./components/ImageWrapper');

var _ImageWrapper2 = _interopRequireDefault(_ImageWrapper);

var _LocationName = require('./components/LocationName');

var _LocationName2 = _interopRequireDefault(_LocationName);

var _LocationLink = require('./components/LocationLink');

var _LocationLink2 = _interopRequireDefault(_LocationLink);

var _MapThumb = require('./components/MapThumb');

var _MapThumb2 = _interopRequireDefault(_MapThumb);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapCTA = function MapCTA(_ref) {
  var hasTopMargin = _ref.hasTopMargin,
      hasBottomMargin = _ref.hasBottomMargin,
      googleAPIKey = _ref.googleAPIKey,
      locationName = _ref.locationName,
      street = _ref.street,
      city = _ref.city,
      state = _ref.state,
      zip = _ref.zip;

  var fullAddress = street + ', ' + city + ', ' + state + ' ' + zip;

  return _react2.default.createElement(
    _Wrapper2.default,
    {
      hasTopMargin: hasTopMargin,
      hasBottomMargin: hasBottomMargin
    },
    _react2.default.createElement(
      _InfoWrapper2.default,
      null,
      _react2.default.createElement(_YellowLineSVG2.default, null),
      _react2.default.createElement(
        _LocationName2.default,
        null,
        locationName
      ),
      _react2.default.createElement(
        _LocationLink2.default,
        {
          href: 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(fullAddress),
          target: '_blank',
          rel: 'noopener noreferrer'
        },
        _react2.default.createElement(
          'span',
          null,
          street
        ),
        _react2.default.createElement(
          'span',
          null,
          city,
          ', ',
          state,
          ' ',
          zip
        )
      )
    ),
    _react2.default.createElement(
      _ImageWrapper2.default,
      null,
      _react2.default.createElement(
        'a',
        {
          href: 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(fullAddress),
          target: '_blank',
          rel: 'noopener noreferrer'
        },
        _react2.default.createElement(_MapThumb2.default, {
          src: 'https://maps.googleapis.com/maps/api/staticmap?markers=' + fullAddress + '&key=' + googleAPIKey + '&zoom=17&size=500x250&scale=2'
        })
      )
    )
  );
};

MapCTA.propTypes = {
  /** Whether or not a 30px bottom margin is applied. */
  hasBottomMargin: _propTypes2.default.bool,
  /** Whether or not a 30px top margin is applied. */
  hasTopMargin: _propTypes2.default.bool,
  /** API key for accessing Google APIs. */
  googleAPIKey: _propTypes2.default.string,
  /** Name of the location */
  locationName: _propTypes2.default.string.isRequired,
  /** Location street */
  street: _propTypes2.default.string.isRequired,
  /** Location city */
  city: _propTypes2.default.string.isRequired,
  /** Location state */
  state: _propTypes2.default.string.isRequired,
  /** Location zip */
  zip: _propTypes2.default.string.isRequired
};

MapCTA.defaultProps = {
  hasBottomMargin: true,
  hasTopMargin: true,
  googleAPIKey: 'AIzaSyB9DCETiPvJTe65GDXGglmM9ZTMbLS9yrk'
};

MapCTA.displayName = 'MapCTA';

exports.default = MapCTA;
MapCTA.__docgenInfo = {
  'description': '',
  'methods': [],
  'displayName': 'MapCTA',
  'props': {
    'hasBottomMargin': {
      'defaultValue': {
        'value': 'true',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': 'Whether or not a 30px bottom margin is applied.'
    },
    'hasTopMargin': {
      'defaultValue': {
        'value': 'true',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': 'Whether or not a 30px top margin is applied.'
    },
    'googleAPIKey': {
      'defaultValue': {
        'value': '\'AIzaSyB9DCETiPvJTe65GDXGglmM9ZTMbLS9yrk\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'API key for accessing Google APIs.'
    },
    'locationName': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': 'Name of the location'
    },
    'street': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': 'Location street'
    },
    'city': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': 'Location city'
    },
    'state': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': 'Location state'
    },
    'zip': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': 'Location zip'
    }
  }
};